import React, { useState } from "react";

export default function StepGoals({ data, onUpdate, onNext, onBack }) {
  const [error, setError] = useState("");

  const validate = () => {
    if (
      !data.preferredCountry ||
      !data.targetLevel ||
      !data.intake ||
      !data.englishTest
    ) {
      setError("Please select all your study preferences.");
      return false;
    }
    setError("");
    return true;
  };

  return (
    <div className="bg-white rounded-2xl p-8 shadow-lg">
      <h2 className="text-xl font-semibold text-primary mb-4">
        Study Goals
      </h2>

      <p className="text-sm text-primary-dark mb-6">
        Help us understand your study plans.
      </p>

      <div className="space-y-4">
        <select
          value={data.preferredCountry}
          onChange={(e) => onUpdate({ preferredCountry: e.target.value })}
          className="w-full px-4 py-3 border rounded-lg"
        >
          <option value="">Preferred Country</option>
          <option value="Canada">Canada</option>
          <option value="UK">UK</option>
          <option value="USA">USA</option>
          <option value="Germany">Germany</option>
          <option value="Australia">Australia</option>
        </select>

        <select
          value={data.targetLevel}
          onChange={(e) => onUpdate({ targetLevel: e.target.value })}
          className="w-full px-4 py-3 border rounded-lg"
        >
          <option value="">Target Level</option>
          <option value="Bachelors">Bachelor’s</option>
          <option value="Masters">Master’s</option>
          <option value="PhD">PhD</option>
        </select>

        <select
          value={data.intake}
          onChange={(e) => onUpdate({ intake: e.target.value })}
          className="w-full px-4 py-3 border rounded-lg"
        >
          <option value="">Preferred Intake</option>
          <option value="Jan">January</option>
          <option value="May">May</option>
          <option value="Sep">September</option>
        </select>

        <select
          value={data.englishTest}
          onChange={(e) => onUpdate({ englishTest: e.target.value })}
          className="w-full px-4 py-3 border rounded-lg"
        >
          <option value="">English Proficiency Test</option>
          <option value="IELTS">IELTS</option>
          <option value="TOEFL">TOEFL</option>
          <option value="PTE">PTE</option>
          <option value="Duolingo">Duolingo</option>
          <option value="Not Taken">Not Taken Yet</option>
        </select>
      </div>

      {error && <p className="text-red-500 text-xs mt-3">{error}</p>}

      <div className="flex justify-between mt-6">
        <button
          onClick={onBack}
          className="text-sm text-primary-dark underline"
        >
          Back
        </button>

        <button
          onClick={() => {
            if (validate()) onNext();
          }}
          className="px-6 py-3 bg-primary text-white rounded-lg text-sm font-medium"
        >
          Continue
        </button>
      </div>
    </div>
  );
}
